import CustomTrigger from "../CustomTrigger";
import { useState } from "react";
import CustomButton from "components/CustomButton";
import { DollarSign } from "lucide-react";
import ModalRealizarCotacao from "components/CustomModal/ModalContent/ModalRealizarCotacao";
import { useTranslation } from "react-i18next";
import SaldoCarteira from "components/SaldoCarteira";

type Props = {
  sidebarOpen: boolean;
  toggleSidebar: (togle: boolean) => void;
};

const Header = ({ sidebarOpen, toggleSidebar }: Props) => {
  const { t } = useTranslation("dashboard");
  const [showModal, setShowModal] = useState(false);
  return (
    <header className="sticky top-0 z-5 flex items-center gap-4 border-b bg-brand-card p-4 px-8">
      <CustomTrigger sidebarOpen={sidebarOpen} toggle={toggleSidebar} />
      <div className="flex justify-between w-full items-center">
        <div>
          <h1 className="text-shopify-h2 text-shopify-dark ">{t("title")}</h1>
          <p className="text-shopify-caption text-shopify-light uppercase">
            {t("subtitle")}
          </p>
        </div>
        <div className="flex items-center gap-3">
        <SaldoCarteira />
        <CustomButton
          className="flex h-12 pl-4 text-shopify-body uppercase bg-brand-sidebar border-brand-sidebar hover:text-brand-sidebar"
          iconDirection="left"
          label={t("buttons.make_quotations")}
          icon={<DollarSign />}
          onClick={() => setShowModal(true)}
        />
        </div>
      </div>
      <ModalRealizarCotacao
        show={showModal}
        setShow={setShowModal}
        title={t("buttons.make_quotations")}
        logo={<DollarSign />}
      />
    </header>
  );
};
export default Header;
